export const FETCHING_USAGE_DETAIL = 'FETCHING_USAGE_DETAIL';
export const SELECTED_USAGE_DETAIL = 'SELECTED_USAGE_DETAIL';
export const CREATE_EDIT_USAGE_ITEMS = 'CREATE_EDIT_USAGE_ITEMS';
export const FETCHING_USAGE_DETAIL_ERROR = 'FETCHING_USAGE_DETAIL_ERROR';
export const USAGE_LOADING = 'USAGE_LOADING';
export const USAGE_DETAIL_SUBMIT = 'USAGE_DETAIL_SUBMIT';
export const SUBMIT_USAGE_DETAIL_ERROR = 'SUBMIT_USAGE_DETAIL_ERROR';
export const SUBMITTING_USAGE_DETAIL = 'SUBMITTING_USAGE_DETAIL';
export const RE_USAGE_ITEM_LIST = 'RE_USAGE_ITEM_LIST';
export const CLEAR_USAGE_ERROR_SUCCESS = 'CLEAR_USAGE_ERROR_SUCCESS';
export const USAGE_ITEMS_LOADING_ERROR = 'USAGE_ITEMS_LOADING_ERROR';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/CreateEditUsage/types.js